import type { ReactNode } from 'react'

import { brandAssetUrl } from '@/runtime'
import { cn } from '@/lib/utils'
import styles from './AuthCard.module.scss'

/** The one centred card every sign-in surface (login, activation) sits in. */
export function AuthCard({
  title,
  subtitle,
  message,
  messageIsError = false,
  children,
}: {
  title: string
  subtitle?: string
  message?: string | null
  messageIsError?: boolean
  children: ReactNode
}) {
  return (
    <main className={styles.page} data-app="progetto_arca">
      <section className={styles.card} aria-labelledby="auth-title">
        <div className={styles.brand}>
          <div className={styles.logo}>
            <img src={brandAssetUrl('progetto-arca-lockup.png')} alt="Progetto Arca" draggable={false} />
          </div>
          <div>
            <h1 id="auth-title" className={styles.title}>
              {title}
            </h1>
            {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          </div>
        </div>
        {children}
        {message ? (
          <p className={cn(styles.message, messageIsError && styles.messageError)} role={messageIsError ? 'alert' : undefined}>
            {message}
          </p>
        ) : null}
      </section>
    </main>
  )
}
